import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { generatePriceTierOrderRuleDescription } from "../../utils/sellarHelpers";

export function PriceTierOrderRuleSummaryLegacy({
  priceTierOrderRules,
}: {
  priceTierOrderRules?: SupplierGetResponseType["CustomerZones"][number]["PriceTier"]["PriceTierOrderRules"];
}) {
  return (
    <>
      {priceTierOrderRules?.map((rule, i) => (
        <div key={i}>{generatePriceTierOrderRuleDescription(rule)}</div>
      ))}
    </>
  );
}
